<template>
  <div>
    <transition name="fade" mode="out-in" appear>
        <router-view />
    </transition>
    <ChatFloating />
  </div>
</template>

<script>
import ChatFloating from './components/ChatFloating.vue';

export default {
  name: 'App',
  components: { ChatFloating },
};
</script>
